<template>
  <b-dropdown
    append-to-body
    aria-role="menu"
    scrollable
    max-height="200"
    trap-focus
    position="is-bottom-left"
  >
    <template #trigger>
      <a class="navbar-item" role="button">
        <span>
          <country-flag :country="currentLanguageCountry()" />
        </span>
      </a>
    </template>

    <b-dropdown-item @click="() => setLocale('nl')">
      <div class="dropdown-item-container">
        <span class="dropdown-item-el">
          <country-flag country="nl" />
        </span>
        <span class="dropdown-item-el">Nederlands</span>
      </div>
    </b-dropdown-item>

    <b-dropdown-item @click="() => setLocale('en')">
      <div class="dropdown-item-container">
        <span class="dropdown-item-el">
          <country-flag country="us" />
        </span>
        <span class="dropdown-item-el">English</span>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>

const axios = require("axios");

import CountryFlag from "vue-country-flag";

export default {
  name: "LanguageDropdown",
  components: {
    CountryFlag
  },
  data: function () {
    return {
      api: axios.create({
        baseURL: process.env.VUE_APP_JOBS_API_ROOT,
        headers: { Authorization: `Bearer ${localStorage.backendToken}` }
      })
    }
  },
  methods: {
    currentLanguageCountry () {
      const languagesMap = {
        "en": "us",
        "nl": "nl"
      }

      return languagesMap[this.$i18n.locale];
    },
    setLocale (locale) {
      const dropdown = this;

      if (localStorage.backendToken != null) {
        // Update the user's preferred language if he/she is signed in
        this.api.post(`/update-language/${locale}`).then(() => {
          this.$i18n.locale = locale;
          localStorage.language = locale;

          dropdown.$buefy.toast.open({
            message: dropdown.$t("misc.languageUpdated"),
            type: "is-success"
          });
        }).catch((error) => {
          console.log(error);

          dropdown.$buefy.toast.open({
            message: dropdown.$t("misc.languageUpdateFailed"),
            type: "is-danger"
          })
        })
      } else {
        // If the user is not signed in only update the local language
        this.$i18n.locale = locale;
        localStorage.language = locale;

        this.$buefy.toast.open({
          message: this.$t("misc.languageUpdated"),
          type: "is-success"
        })
      }
    }
  }
};

</script>

<style scoped>

.dropdown-item-container {
  display: flex;
  gap: 8px;
}

.dropdown-item-el {
  margin-top: auto;
  margin-bottom: auto;
}

</style>